import packageJson from "../../package.json";

export interface VersionInfo {
  version: string;
  commit: string;
  branch: string;
  buildDate: string;
}

// This will be replaced at build time by Vite
declare global {
  const __VERSION_INFO__: VersionInfo;
}

export const VERSION_INFO: VersionInfo =
  typeof __VERSION_INFO__ !== "undefined"
    ? __VERSION_INFO__
    : {
        version: packageJson.version,
        commit: "development",
        branch: "local",
        buildDate: new Date().toISOString(),
      };
